export const MERGE_ENTITIES = 'app/store/entities/MERGE_ENTITIES';
export const REPLACE_ENTITIES = 'app/store/entities/REPLACE_ENTITIES';
